export default __webpack_public_path__ + "static/media/Captain's Armguards of the Watchtowers.83f670bf.jpg";